<template>
	<div>
		<!-- Badge with link -->
		<nuxt-link
			v-if="badge.url && badge.icon"
			:key="badge.title"
			:to="badge.url"
			tabindex="-1"
			:title="t('info')"
			class="relative z-50"
			target="_blank"
		>
			<v-product-card-badge :badge="badge">
				{{ badge.title }}
			</v-product-card-badge>
		</nuxt-link>

		<!-- Badge without link -->
		<div
			v-if="badge.icon && !badge.url"
			:key="badge.title"
			tabindex="-1"
			class="relative z-50"
		>
			<v-product-card-badge :badge="badge">
				{{ badge.title }}
			</v-product-card-badge>
		</div>
	</div>
</template>

<script setup lang="ts">
import {type ViewProductDetailsQuery} from "@pkg/shared/graphql";

type DetailProduct = Extract<
	ViewProductDetailsQuery["product"],
	{__typename: "SimpleProduct"}
>;

type ProductBadge = DetailProduct["productBadges"][0];

defineProps<{
	badge: ProductBadge;
}>();

const {t} = useI18n();
</script>

<i18n lang="json">
{
	"et": {
		"info": "Lisateave"
	},
	"fi": {
		"info": "Lisätietoja"
	}
}
</i18n>
